var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 16 18)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 17,
    height: 22,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 13,
    height: 18,
    fill: "#800020"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 11,
    height: 16,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeDasharray: "1,1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(10 16 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 17,
    height: 22,
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 10,
    fontFamily: "Times New Roman, serif",
    fontSize: 7,
    fontWeight: "bold",
    fill: "#cc0000"
  }, "A"), /*#__PURE__*/React.createElement("path", {
    d: "M19 13 h1 v1 h1 v1 h1 v1 h1 v-1 h1 v-1 h1 v-1 h1 v3 h-1 v1 h-1 v1 h-1 v1 h-1 v1 h-1 v-1 h-1 v-1 h-1 v-1 h-1 v-1 h-1 v-3 h1 z",
    fill: "#cc0000"
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 22,
    fontFamily: "Times New Roman, serif",
    fontSize: 7,
    fontWeight: "bold",
    fill: "#cc0000",
    transform: "rotate(180 26 22)"
  }, "A"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard32);
export default __webpack_public_path__ + "static/media/card32.e85bc25f77668266139d1be8f82fda66.svg";
export { ForwardRef as ReactComponent };